class PriceTaxLabel {
  constructor(root) {
    this.root = root;
    this.label = root.dataset.taxLabel;
    if (!this.label) return;

    this.ensureLabel();
    this.observer = new MutationObserver(() => this.ensureLabel());
    this.observer.observe(root, { childList: true, subtree: true });
  }

  ensureLabel() {
    const numberEl = this.root.querySelector('.price__number');
    if (!numberEl || numberEl.querySelector('.price__tax-label')) return;

    const moneyEl = numberEl.querySelector('.money');
    if (!moneyEl) return;

    moneyEl.textContent = moneyEl.textContent.trim();

    const span = document.createElement('span');
    span.className = 'price__tax-label';
    span.style.fontSize = '.65em';
    span.textContent = this.label;
    moneyEl.insertAdjacentElement('afterend', span);
  }
}

document.querySelectorAll('.price[data-tax-label]').forEach((el) => new PriceTaxLabel(el));
